var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-nav-bar',{attrs:{"title":"เพิ่มเติม"}}),_c('van-row',[_c('van-empty',{attrs:{"description":"Description"}})],1),_c('Tabbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }